<template>
    
        
    <v-container
        class="spacing-playground pa-6"
        fluid
    >
        <v-row class="mb-4 mt-2" align="center" justify="center" >
            <v-flex lg12>
                <v-img
                    src="https://my.ipaymu.com/asset/images/logo-ipaymu.png"
                    max-height="120"
                    max-width="120"
                    aspect-ratio="1"
                    class="m-auto"
                ></v-img>
            </v-flex>
            <!-- <v-flex lg12  class="mt-2">
                <h4 align="center" justify="center">iPaymu Status</h4>
            </v-flex> -->
            
        </v-row>
        <list-health-check></list-health-check>
    </v-container>
    <!-- <footer-page></footer-page> -->
    
</template>

<script>
    // import FooterPage from '../Footer.vue';
    import ListHealthCheck from '../../components/healthcheck/ListHealthCheck.vue';

    export default {
        components: {
            ListHealthCheck,
            // FooterPage
        }
    };
</script>